import {useField} from 'formik';
import {useMemo, useCallback} from 'react';

import {WorkingHoursTimePoint} from 'types';

import {TimePicker, TimePickerProps} from './TimePicker';

type Props = {
    name: string;
    required?: boolean;
} & Omit<TimePickerProps, 'value' | 'onChange'>;

export const TimePickerFormik: React.FC<Props> = ({name, required, ...rest}: Props) => {
    const [field, meta, helper] = useField(name);

    const hasError = useMemo<boolean>(
        () => meta.error && (meta.touched || meta.value) || meta.touched && required && !meta.value,
        [meta, required]
    );

    const handleBlur = useCallback((e: React.FocusEvent) => {
        field.onBlur(e);
    }, [field]);

    const onChangeHandler = useCallback((value: WorkingHoursTimePoint) => {
        helper.setValue(value);
    }, [helper]);

    return (
        <TimePicker
            {...rest}
            name={name}
            value={field.value}
            required={required}
            hasError={hasError}
            errorMessage={meta.error}
            onBlur={handleBlur}
            onChange={onChangeHandler}
        />
    );
};